import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {createDeliveryConfirmFile} from "../../../../../api/order/OrdersApi";


export const useCreateDeliveryConfirmFile = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: FormData) => createDeliveryConfirmFile(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "저장되었습니다",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readShipmentDeliveryConfirm"]})
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
